<template>
  <div class="payment-info normal-payment">
    <div class="payment-header">支払情報</div>
    <div class="payment-content">
      <div class="payment-row d-flex justify-content-between">
        <div class="payment-label">お振込日</div>
        <div class="payment-value">{{ paymentDate }}</div>
      </div>
      <div class="payment-row d-flex justify-content-between">
        <div class="payment-label">金額</div>
        <div class="payment-value amount">{{ amount }}円</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NormalPaymentInfo',
  props: {
    paymentDate: {
      type: String,
      default: ''
    },
    amount: {
      type: String,
      default: '0'
    }
  }
};
</script>

<style scoped>
.payment-info {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.payment-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  font-weight: 600;
  border-radius: 4px 4px 0 0;
}

.payment-content {
  padding: 15px;
}

.payment-row {
  padding: 8px 0;
  border-bottom: 1px dotted #ddd;
}

.payment-row:last-child {
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.payment-value.amount {
  font-weight: 600;
  color: #e74c3c;
}
</style> 